const REQUEST_START = 'landing-page-analyze/REQUEST_START';
const REQUEST_FAILED = 'landing-page-analyze/REQUEST_FAILED';

const FETCH_REPORT = 'landing-page-analyze/FETCH_REPORT';
const FETCH_REPORT_SUCCEEDED = 'landing-page-analyze/FETCH_SUCCEEDED';

const UPDATE_PAGE = 'landing-page-analyze/UPDATE_PAGE';
const UPDATE_SORT = 'landing-page-analyze/UPDATE_SORT';

export default {
  REQUEST_START,
  REQUEST_FAILED,

  FETCH_REPORT,
  FETCH_REPORT_SUCCEEDED,

  UPDATE_PAGE,
  UPDATE_SORT,
};
